module.exports = __webpack_public_path__ + "static/media/privacy-lock-2x.f2847273.png";